import { type FC, type ReactNode } from "react";

import { clsx } from "clsx";

export const PaneDrawer: FC<{
  children: ReactNode;
}> = ({ children }) => (
  <div className="h-full w-48 shrink-0 grow-0 overflow-y-scroll bg-slate-100">
    {children}
  </div>
);

export const PaneContent: FC<{
  children: ReactNode;
}> = ({ children }) => (
  <div className="h-full shrink grow overflow-y-scroll">{children}</div>
);

export const Pane: FC<{
  children: ReactNode;
  fullHeight?: boolean;
}> = ({ children, fullHeight = false }) => (
  <div
    className={clsx(
      "flex divide-x divide-slate-200 overflow-hidden rounded-md border border-slate-200",
      // fullHeight fills the remaining space of a `<Page fill>` flex column,
      // so the pane (and its scrolling columns) adapt to the real header
      // height instead of assuming a fixed one-line header.
      fullHeight ? "min-h-0 flex-1" : "h-full",
    )}
  >
    {children}
  </div>
);
